import React from 'react';

import InputLabel, { InputLabelClassKey } from '@material-ui/core/InputLabel';

interface ILabelProps {
  id: string;
  label: string;
  classes?: Partial<Record<InputLabelClassKey, string>>;
}

export const Label = ({ id, classes, label }: ILabelProps) => (
  <InputLabel
    classes={{
      ...classes,
      root: `input-label override ${classes ? classes.root || '' : ''}`,
      shrink: `input-label--shrink override ${classes ? classes.shrink || '' : ''}`
    }}
    htmlFor={id}
  >
    {label}
  </InputLabel>
);
